<template>
  <div>
    <el-dialog
      append-to-body
      title="版本信息"
      :visible.sync="dialogVisible"
      width="560px"
      @open="getDataList"
      :before-close="handleClose"
    >
      <div class="currentVersion">
        <img
          class="logo"
          src="../../assets/images/img_update_logo.png"
          alt=""
        />
        <div class="current">
          <p>
            <span>当前版本：</span><span>V {{ newVersion.version }}</span>
          </p>
          <p>
            <span>更新日期：</span><span>{{ newVersion.createDate }}</span>
          </p>
        </div>
      </div>
      <div class="versions">
        <div class="title">版本更新信息：</div>
        <div class="lists" v-if="dataList.length > 0">
          <div class="list" v-for="item in dataList" :key="item.id">
            <p>V {{ item.version }} （{{ item.createDate }}）</p>
            <p>更新内容：</p>
            <p v-html="item.log"></p>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" center>
        <el-button type="primary" @click="handleClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Version",
  data() {
    return {
      dataList: [],
      newVersion: {},
    };
  },
  props: {
    dialogVisible: Boolean,
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    getDataList() {
      if (this.dataList.length == 0) {
        this.axios
          .post("api/setting/GetVersion")
          .then((res) => {
            if (res.data.resultType == 0) {
              this.dataList = res.data.appendData;
              if (res.data.appendData.length > 0)
                this.newVersion = res.data.appendData[0];
            } else {
              this.$alert(res.data.message);
            }
          })
          .catch((err) => {
            this.$alert(err);
          });
      }
    },
  },
};
</script>

<style scoped lang="less">
.currentVersion {
  margin-bottom: 30px;
  .logo {
    width: 45px;
    height: 45px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 12px;
  }
  .current {
    vertical-align: middle;
    display: inline-block;
    font-size: 14px;
    span:nth-child(1) {
      color: #121212;
    }
    span:nth-child(2) {
      color: #525252;
    }
  }
}
.versions {
  /*min-height: 380px;*/
  height: 380px;
  background: #fbfbfb;
  font-size: 13px;
  color: #161616;
  padding: 13px 20px;
  overflow: auto;
  .lists {
    .list {
      padding: 16px 0;
    }
  }
}
/deep/ .el-dialog__footer {
  text-align: center;
  padding-top: 0;
  .el-button {
    width: 130px;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Version.vue